import { ComponentProps, useId, ReactNode } from 'react';
import styles from './radio.module.scss';
import { InvalidFeedback } from '../InvalidFeedback/InvalidFeedback';
// import { VALIDITY } from '@/constants/validity';

export interface Radio extends ComponentProps<'input'> {
    invalid?: FieldValidityState;
    label: ReactNode;
    invalidMessage?: string;
    dataCy?: string;
}

export function RadioButton({ invalid, label, invalidMessage, id, dataCy, ...otherProps }: Radio): React.JSX.Element {
    const generatedId = useId();
    const elementId = id ? id : generatedId;
    const errorId = `${elementId}-error`;
    // const ariaInvalid = invalid === VALIDITY.invalid;

    return (
        <>
            {invalid && invalidMessage && (
                <InvalidFeedback validState={invalid} errorId={errorId}>
                    {invalidMessage}
                </InvalidFeedback>
            )}
            <div className={styles.radioItem}>
                <input
                    {...otherProps}
                    className={styles.radio}
                    type="radio"
                    id={elementId}
                    // aria-invalid={ariaInvalid}
                    data-cy={dataCy}
                />
                <label className="input-label" htmlFor={elementId}>
                    {label}
                </label>
            </div>
        </>
    );
}
